import React from "react";

function Pagination({ currentPage, isDisable, totalPages, onPageChange }) {
  const pageNumbers = [];
  const delta = 2;
  let left = currentPage - delta;
  let right = currentPage + delta;
  
  // Ensure bounds
  if (left < 1) left = 1;
  if (right > totalPages) right = totalPages;

  // Always include first page
  if (left > 1) pageNumbers.push(1);
  if (left > 2) pageNumbers.push("...");

  // Add middle range
  for (let i = left; i <= right; i++) {
    pageNumbers.push(i);
  }

  // Add right ellipsis and last page if needed
  if (right < totalPages - 1) pageNumbers.push("...");
  if (right < totalPages) pageNumbers.push(totalPages);


  return (
    <ul className="pagination">
      <li className={`page-item previous ${isDisable?'disabled':''} ${currentPage === 1 ? "disabled" : ""}`}>
        <a
          className="page-link"
          onClick={(e) => {
            e.preventDefault();
            if (currentPage > 1) onPageChange(currentPage - 1);
          }}
        >
         <i className='previous'></i>
        </a>
      </li>
      {pageNumbers.map((number, index) =>
        number === "..." ? (
          <li key={`ellipsis-${index}`} className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        ) : (
          <li
            key={`page-${number}`}
            className={`page-item ${isDisable?'disabled':''} ${currentPage === number ? "active" : ""}`}
          >
            <a
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                onPageChange(number);
              }}
            >
              {number}
            </a>
          </li>
        )
      )}
      <li className={`page-item next ${isDisable?'disabled':''} ${currentPage === totalPages ? "disabled" : ""}`}>
        <a
          className="page-link "
          onClick={(e) => {
            e.preventDefault();
            if (currentPage < totalPages) onPageChange(currentPage + 1);
          }}
        >
         <i className='next'></i>
        </a>
      </li>
    </ul>
  );
}

export default Pagination;
